import { isPast } from "date-fns/esm";

import { Activity } from "@mapmycustomers/shared/types/entity";

import isValidDate from "@app/util/isValidDate";
import { parseApiDate } from "@app/util/parsers";

const isFutureActivity = (activity: Activity): boolean | undefined => {
  const startAt = parseApiDate(activity.startAt ?? "");
  if (!isValidDate(startAt)) {
    return undefined;
  }
  return !isPast(startAt);
};

export default isFutureActivity;
